import { createRoute } from '@tanstack/react-router';
import { LedgersPage } from '@/features/finance/Ledgers';
import { Route as shellRoute } from '../_shell';

export const Route = createRoute({
  getParentRoute: () => shellRoute,
  path: '/finance/ledgers',
  component: LedgersPage,
});
